import React from "react";
import transferImg from "../../../styles/img/transfer_icon.png";

export const TransferIcon = (props) => {
  return (
    <>
      <img className="df-w-46" src={props?.icon || transferImg} />
    </>
  );
};
